import { UseGetApiSimple, UseGetApiBlob, UsePostApi, UsePutApi } from "beaktShared/services/crudeApiService";

const ENDPOINT = "Comunicados";

// Evento disparado apos criar, editar ou inativar comunicado; o layout da Matriz atualiza o badge do menu
const EVENTO_COMUNICADOS_ATUALIZADOS = "comunicados:atualizado";
const notificarComunicadosAtualizados = () => window.dispatchEvent(new Event(EVENTO_COMUNICADOS_ATUALIZADOS));

// Enums espelhados de api/Models/Matriz/Comunicado.cs e api/Dtos/Matriz/ComunicadoDto.cs
const TipoComunicado = {
    AvisoSistema: 1,
    InformativoUnidade: 2,
    Alerta: 3,
};

const SituacaoComunicado = {
    Ativo: 1,
    Inativo: 2,
    Pendente: 3, // Rascunho: ainda nao publicado
};

const TipoEscopoComunicado = {
    Matriz: 1, // Todos os usuarios Matriz da franquia
    Estabelecimento: 2, // Usuarios das unidades informadas; sem unidades = todas as unidades da franquia
};

const SituacaoAdesaoComunicado = {
    Aceito: 1,
    Pendente: 2,
};

const SituacaoPrazoAceite = {
    SemPrazo: 1,
    DentroDoPrazo: 2,
    AceitoAposPrazo: 3,
    PrazoVencido: 4,
};

const buildQueryString = (params) => {
    const parts = Object.keys(params)
        .filter((key) => params[key] !== null && params[key] !== undefined && params[key] !== "")
        .map((key) => `${key}=${encodeURIComponent(params[key])}`);
    return parts.length > 0 ? `?${parts.join("&")}` : "";
};

// Padroniza o retorno do crudeApiService em { ok, data, message }.
// O helper retorna undefined quando a sessao expira (recarrega a pagina) e,
// nos erros de POST, a mensagem pode vir como objeto { status, message }.
const normalizarResultado = (promise) =>
    Promise.resolve(promise).then((result) => {
        if (!result) {
            return { ok: false, data: null, message: "" };
        }
        const ok = result.status >= 200 && result.status < 300;
        const message = result.message && typeof result.message === "object"
            ? result.message.message
            : result.message;
        return { ok, data: result.data, message: message || "" };
    });

// filtro: { franquiaId, dataIni: "YYYY-MM-DD", dataFim: "YYYY-MM-DD", tipo, situacao }
const listar = (filtro) =>
    normalizarResultado(UseGetApiSimple(`${ENDPOINT}${buildQueryString(filtro)}`));

// Inativacao logica - o comunicado nunca e excluido fisicamente
const inativar = (comunicadoId) =>
    normalizarResultado(UsePostApi(`${ENDPOINT}/${comunicadoId}/inativar`, {}));

// Detalhe com descricao, unidades destinatarias e anexos
const obter = (comunicadoId) =>
    normalizarResultado(UseGetApiSimple(`${ENDPOINT}/${comunicadoId}`));

// dto: ComunicadoSalvarDto - publicar=false salva como rascunho (Pendente), publicar=true publica (Ativo)
const criar = (dto) => normalizarResultado(UsePostApi(ENDPOINT, dto));

const editar = (comunicadoId, dto) => normalizarResultado(UsePutApi(`${ENDPOINT}/`, comunicadoId, dto));

const listarEstabelecimentosAtivos = (franquiaId) =>
    normalizarResultado(UseGetApiSimple(`estabelecimentos/ativos/byfranquia/${franquiaId}`));

// Relatorio de adesao (ComunicadoLogAceitesDto): somente leitura, os aceites sao imutaveis
const obterLogAceites = (comunicadoId) =>
    normalizarResultado(UseGetApiSimple(`${ENDPOINT}/${comunicadoId}/log-aceites`));

// CSV gerado pelo servidor (UTF-8 com BOM, separador ";"); retorna { ok, blob, message }
const exportarLogAceitesCsv = (comunicadoId) =>
    Promise.resolve(UseGetApiBlob(`${ENDPOINT}/${comunicadoId}/log-aceites/csv`)).then((result) => {
        const ok = !!result && result.status >= 200 && result.status < 300;
        return ok ? { ok, blob: result.data } : { ok, message: "Erro ao exportar CSV" };
    });

// Quantidade de comunicados ativos que ainda possuem destinatarios pendentes de aceite (badge do menu da Matriz)
const contarComPendencias = (franquiaId) =>
    listar({ franquiaId: franquiaId, situacao: SituacaoComunicado.Ativo }).then(result => ({
        ok: result.ok,
        total: result.ok ? (result.data || []).filter(c => c.totalPendentes > 0).length : 0,
    }));

export {
    TipoComunicado,
    SituacaoComunicado,
    TipoEscopoComunicado,
    SituacaoAdesaoComunicado,
    SituacaoPrazoAceite,
    EVENTO_COMUNICADOS_ATUALIZADOS,
    notificarComunicadosAtualizados,
    listar,
    inativar,
    obter,
    criar,
    editar,
    listarEstabelecimentosAtivos,
    obterLogAceites,
    exportarLogAceitesCsv,
    contarComPendencias,
};
